// src/components/auth/SocialDivider.jsx
import React from "react";

const SocialDivider = ({ text = "or continue with" }) => (
  <div className="relative flex items-center gap-3 my-1">
    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-slate-200 to-slate-200" />
    <span className="text-xs font-semibold text-slate-400 tracking-widest uppercase whitespace-nowrap px-1">
      {text}
    </span>
    <div className="flex-1 h-px bg-gradient-to-l from-transparent via-slate-200 to-slate-200" />
  </div>
);

export default SocialDivider;
